export const qk = {
  project: ["project"] as const,
  phases: ["phases"] as const,
  phase: (id: string) => ["phases", id] as const,
  tasks: ["tasks"] as const,
  task: (id: string) => ["tasks", id] as const,
  quotes: ["quotes"] as const,
  quote: (id: string) => ["quotes", id] as const,
  expenses: ["expenses"] as const,
  expense: (id: string) => ["expenses", id] as const,
  contacts: ["contacts"] as const,
  contact: (id: string) => ["contacts", id] as const,
  documents: ["documents"] as const,
  document: (id: string) => ["documents", id] as const,
  siteDailyLogs: ["siteDailyLogs"] as const,
  projectState: ["projectState"] as const,
  projectFacts: ["projectFacts"] as const,
  procurement: ["procurement"] as const,
  checklist: ["checklist"] as const,
  checklistByOwner: (ownerType: "phase" | "task", ownerId: string) =>
    ["checklist", ownerType, ownerId] as const,
  botSettings: ["botSettings"] as const,
  botRuns: ["botRuns"] as const,
  botAlerts: ["botAlerts"] as const,
  botWatchRules: ["botWatchRules"] as const,
  emailDrafts: ["emailDrafts"] as const,
  emails: ["emails"] as const
};

